import { LOCAL__grid2d_upsert } from '@/state/grid2d/grid2d/LOCAL__grid2d_upsert';
import { store } from '@/state/store';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';

export function FN_IMAGE_ASSET__add_to_grid2d(images: DTO__image_asset[]) {
  //key - grid2d_id
  let updated_grid2d_map: MAP__serializable<string, DTO__grid2d> = new MAP__serializable();

  for (let image of images) {
    try_set_image_to_grid2d_cell(image, updated_grid2d_map);
  }

  if (updated_grid2d_map.is_empty()) return;

  store.dispatch(LOCAL__grid2d_upsert(updated_grid2d_map.values()));
}

function try_set_image_to_grid2d_cell(image: DTO__image_asset, updated_grid2d_map: MAP__serializable<string, DTO__grid2d>) {
  let { grids2d_map } = store.getState().slice_grid2d;

  for (let grid2d of grids2d_map.values()) {
    let cells_list = grid2d.cells__get_loaded();

    for (let cell of cells_list) {
      if (cell.hash_sha256_content != image.hash_sha256_content) continue;
      if (!cell.image.is_stub()) continue; //already initialized

      cell.image = image.clone();

      updated_grid2d_map.set(grid2d._id, grid2d);
    }
  }
}
